import { render } from "./RankItem.vue?vue&type=template&id=f64ddac8"
import script from "./RankItem.vue?vue&type=script&lang=js"
export * from "./RankItem.vue?vue&type=script&lang=js"

import "./RankItem.vue?vue&type=style&index=0&id=f64ddac8&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__